import { AUTH_ROUTES } from "@repo/contract/iam";
import { toApiError } from "./api-error";
/**
 * `DELETE /auth/account` (`D153`): the account closes, the person's own
 * conversations are erased, the training history stays in the closed account.
 *
 * ── A 204 IS THE WHOLE ANSWER ──────────────────────────────────────────────
 * There is no body to validate and no field a screen could read: the account
 * is gone by the time the response exists. Everything else — the credential
 * on this device, the push token, the status the screens key off — is local
 * state, and it is the CALLER's to end. This function does not touch it,
 * because it must not: the server has already revoked the whole refresh
 * family, so the ordinary sign-out (`ApiClient.signOut`, which POSTs
 * `/auth/signout` with a fresh token) would present a credential the server
 * has just told it is dead. The local clear is `ApiClient.discardSession()`.
 *
 * ── THE ONE REFUSAL A SCREEN SHOULD EXPECT ─────────────────────────────────
 * A person who owns groups that still have members cannot close their account
 * until the groups are handed over or emptied. The server says so as
 * `409 account.owns_populated_groups` with `params { groupCount, groupNames,
 * memberCount }`, and nothing has been erased when it does (`T17`). Under
 * `D27` that is a key plus values, not a sentence: `toApiError` keeps both on
 * the {@link ApiError}, and `useErrorMessage` renders them in the running
 * locale. The names come through verbatim — they are the groups' own.
 *
 * The error is not mapped to a class of its own. The screen has nothing to
 * BRANCH on: the account is either closed or it is not, and every refusal is
 * a sentence to show and a row to press again. `delete-account.test.ts`
 * proves the sentence survives the trip — key, params and all.
 */
export async function deleteAccount(fetcher) {
    const response = await fetcher(AUTH_ROUTES.deleteAccount, {
        method: "DELETE",
    });
    if (!response.ok) {
        throw await toApiError(response);
    }
}
//# sourceMappingURL=delete-account.js.map